module.exports = __webpack_public_path__ + "static/img/share_lead.cbd9707e.png";